import { PersonHttpHelper, NO_DATA_MESSAGE } from '../../utils/HttpHelper';

const DeletePersonOrgRoleData = (personId, personOrgRoleId, state, setState) => {
  if (state.isSaving !== true && !state.message) {
    const newState = {
      ...state,
      isSaving: true,
      isSaved: false,
      message: 'Deleting...'
    };
    setState(newState);

    const personIdForUrl = personId ? encodeURIComponent(personId) : 0;
    const personOrgRoleIdForUrl = personOrgRoleId ? encodeURIComponent(personOrgRoleId) : 'NaN';

    const url = `/Person/${personIdForUrl}/orgRole/${personOrgRoleIdForUrl}`;
    PersonHttpHelper(url, 'DELETE')
      .then((objData) => {
        if (!objData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          setState({
            ...newState,
            isObjLoaded: true,
            isSaving: false,
            isSaved: true,
            objData,
            message: ''
          });
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isObjLoaded: false,
          isSaving: false,
          isSaved: false,
          message: message
        });
      });
  }
};

export default DeletePersonOrgRoleData;